module.exports = __webpack_public_path__ + "img/logo-mini.d4cd3930.svg";